// extracted by mini-css-extract-plugin
module.exports = {"exerciseItemAvatar":"CustomizedAvatar_exerciseItemAvatar__1PqMe"};